module.exports = __webpack_public_path__ + "img/bg_tk_bf_con_u.dbce380e.png";